<template>
    <div>
        <div class="alert-bar" v-if="editingLog">You are editing a completed log.</div>
        <div class="spacer s60" v-if="editingLog"></div>
        <h1 v-if="currentLogData.checklistName">
            {{ currentLogData.checklistName }}&nbsp;
            <span v-if="currentLogData.logDescription" class="button is-cancel" @click="showDescription = true">
                <font-awesome-icon icon="info-circle" />
            </span>
        </h1>

        <!-- {{ currentLogMeta.vesselID }} -->
        <!-- <pre>{{ currentLogMeta }}</pre>
        {{ currentVesselID }} -->

        <div v-if="currentLogMeta.vesselName" class="vessel-name">
            <div>
                <span>{{ currentLogMeta.vesselName }}</span>
                <span v-if="currentVessel && this.currentLogMeta.isFleet">,&nbsp; {{ currentVessel.vesselName }}</span>
            </div>
            <div v-if="autoKeyUsed && formError == ''">
                <div class="key-field"><font-awesome-icon icon="key" /> &nbsp;Key: {{ isEditing ? savedAutoKey : newAutoKeyResult }}</div>
            </div>
            <div v-if="isEditing && savedAutoKey && savedAutoKey != ''">Saved Key: {{ savedAutoKey }}</div>
        </div>

        <div class="spacer s10"></div>

        <div v-if="!loadingFields">
            <div v-if="currentLogData.webLinkCrewOnly">
                <div class="spacer s10"></div>
                <hr />
                <p>Currently logged in as: {{ userData.username }}</p>
            </div>
            <div class="spacer s20"></div>

            <div v-if="fieldGroups.length > 0">
                <div v-for="(fieldGroup, inx) in fieldGroups" :key="`group-${inx}`" class="form-section">
                    <div v-for="(field, index) in fieldGroup.subField" :key="`group-${index}`">
                        <div v-show="showCustomField(field)" class="notification" @click="reviewing = false">
                            <h3
                                :class="{
                                    red: isFieldRequiredMissing(field)
                                }">
                                <span><font-awesome-icon :icon="allIcons[field.type]" /></span>&nbsp; {{ field.label }}
                            </h3>

                            <div v-if="!noPromptFields.includes(field.type) && field.prompt != ''" class="field-prompt">
                                {{ field.prompt }}
                            </div>
                            <div v-else class="spacer s10"></div>

                            <div class="field-type" v-if="field.type == 'text' && answersCollection[field.id].answer">
                                <div class="text-field" :class="{ first: idx == 1 }" v-for="idx in field.answerCount" :key="`text-${inx}-${idx}`">
                                    <div class="text-input">
                                        <input value="" type="text" v-model="answersCollection[field.id].answer[idx - 1]" />
                                    </div>
                                    <div v-if="idx > 1" class="text-remove">
                                        <button class="button is-delete" @click="removeTextField(field, idx)">
                                            <font-awesome-icon icon="trash-alt" />
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="right-align" v-if="field.canRepeat">
                                <div class="spacer s10"></div>
                                <button :disabled="field.answerCount > 9" class="button is-info is-small" @click="addTextField(field)">
                                    <font-awesome-icon icon="plus" />&nbsp;Add another answer
                                </button>
                            </div>

                            <div class="field-type" v-if="field.type == 'number'">
                                <div>
                                    <input
                                        class="input"
                                        type="number"
                                        v-model="answersCollection[field.id].answer[0]"
                                        @keypress="isNumber($event, 10, true)" />
                                </div>
                            </div>

                            <div class="field-type" v-if="field.type == 'table'">
                                <div class="input-table">
                                    <table class="table is-bordered is-fullwidth" v-if="field.tableData && field.tableData.length > 0">
                                        <tbody>
                                            <tr v-for="irx in field.tableRows" :key="`row-${irx}`">
                                                <td
                                                    v-for="icx in field.tableCols"
                                                    :key="`col-${icx}`"
                                                    :class="{
                                                        greyed: field.tableData[getIndex(irx - 1, icx - 1, field.tableCols)].type === 'check'
                                                    }">
                                                    <div v-if="field.tableData[getIndex(irx - 1, icx - 1, field.tableCols)].type === 'text'">
                                                        <input
                                                            type="text"
                                                            class="input borderless"
                                                            :disabled="!field.freeCells.includes(getIndex(irx - 1, icx - 1, field.tableCols))"
                                                            :class="[
                                                                {
                                                                    theader:
                                                                        (field.tableHeaders === 'top' && irx === 1) ||
                                                                        (field.tableHeaders === 'left' && icx === 1) ||
                                                                        (field.tableHeaders === 'both' && (irx === 1 || icx === 1))
                                                                },
                                                                {
                                                                    'cell-locked': !field.freeCells.includes(
                                                                        getIndex(irx - 1, icx - 1, field.tableCols)
                                                                    )
                                                                }
                                                            ]"
                                                            v-model="answersCollection[field.id].answer[getIndex(irx - 1, icx - 1, field.tableCols)]"
                                                            :placeholder="
                                                                (field.tableHeaders === 'top' && irx === 1) ||
                                                                (field.tableHeaders === 'left' && icx === 1) ||
                                                                (field.tableHeaders === 'both' && (irx === 1 || icx === 1))
                                                                    ? 'Header'
                                                                    : ''
                                                            "
                                                            @input="fieldEdited = true" />
                                                    </div>
                                                    <div v-else>
                                                        <div class="check-cell centered">
                                                            <input
                                                                class="is-checkradio"
                                                                type="checkbox"
                                                                :id="`${field.id}-check-${irx}-${icx}`"
                                                                v-model="
                                                                    answersCollection[field.id].answer[getIndex(irx - 1, icx - 1, field.tableCols)]
                                                                " />
                                                            <label :for="`${field.id}-check-${irx}-${icx}`"></label>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p v-else class="text-center text-gray-500 p-4">Adjust rows/columns to create your table.</p>
                                </div>
                            </div>

                            <div class="field-type" v-if="field.type == 'paragraph'">
                                <textarea class="textarea" v-model="answersCollection[field.id].answer[0]">
                              Paragraph
                            </textarea
                                >
                            </div>

                            <div v-if="field.type == 'crew'" class="field-type crew-picker">
                                <div class="hidden">{{ fieldGroups[inx].subField[index].answer }}</div>
                                <div
                                    class="crew-member"
                                    v-for="(crew, ix) in fieldGroups[inx].subField[index].answer"
                                    :key="`${field.id}-check-${ix}`">
                                    <span class="avatar-wrapper">
                                        <span
                                            v-if="crew.avatarUrl != ''"
                                            :style="{ backgroundImage: `url(${crew.avatarUrl})` }"
                                            class="avatar"></span>
                                        <span v-else class="avatar">{{ getAvatar(crew.name) }}</span>
                                    </span>
                                    <span class="crew-name">{{ crew.name }}</span>
                                    <span class="delete" @click="removeCrew(inx, index, crew.id, field.id)">Remove</span>
                                </div>
                                <div class="spacer s10"></div>
                                <button
                                    class="button is-info is-small"
                                    @click="
                                        selectedField = fieldGroups[inx].subField[index];
                                        showAddCrew = true;
                                    ">
                                    <font-awesome-icon icon="plus" />&nbsp;Add Crew
                                </button>
                            </div>

                            <div class="field-type" v-if="field.type == 'dumbphoto'">
                                <img :src="field.prompt" :alt="field.label" />
                            </div>

                            <div class="field-type" v-if="field.type == 'upload'">
                                <div v-if="answersCollection[field.id].answer && answersCollection[field.id].answer?.length > 0" class="image-div">
                                    <ul class="uploads">
                                        <draggable
                                            v-model="answersCollection[field.id].answer"
                                            class="sorting-list"
                                            group="people"
                                            @start="drag = true"
                                            @end="orderChanged()">
                                            <li
                                                class="image-wrap"
                                                v-for="(image, index) in answersCollection[field.id].answer"
                                                :key="`image2-${index}`">
                                                <img :src="image" />
                                                <span class="cross" @click="deleteImage(answersCollection[field.id].answer, index)">
                                                    <font-awesome-icon icon="times" />
                                                </span>
                                            </li>
                                        </draggable>
                                    </ul>
                                </div>
                                <div v-if="answersCollection[field.id].answer?.length < 1">
                                    <vue-dropzone
                                        ref="imgDropZone"
                                        :id="`customdropzone-uploader-${field.id}`"
                                        :options="dropzoneOptions"
                                        @vdropzone-file-added="
                                            (file) => {
                                                selectedField = answersCollection[field.id].answer;
                                                afterComplete(file, field.id);
                                            }
                                        "></vue-dropzone>
                                </div>
                            </div>

                            <div class="field-type trimmed" v-if="field.type == 'dumbtext'">
                                <div v-for="(line, idx) in field.prompt.split('\n')" :key="`line1-${idx}`">{{ line }}<br /></div>
                            </div>

                            <div v-if="field.type == 'checkboxes' && field.options.length > 0" class="field-type checkbox-wrapper">
                                <div class="field" v-for="(option, ix) in field.options" :key="`${field.id}-check-${ix}`">
                                    <input
                                        class="is-checkradio"
                                        type="checkbox"
                                        :id="`${field.id}-option-${inx}-${index}-${ix}`"
                                        :value="option"
                                        v-model="answersCollection[field.id].answer" />
                                    <label :for="`${field.id}-option-${inx}-${index}-${ix}`">{{ option }}</label>
                                </div>
                            </div>

                            <div v-if="field.type == 'dropdown' && field.options.length > 0" class="field-type form-group-reg">
                                <div class="select">
                                    <select v-model="answersCollection[field.id].answer">
                                        <option disabled value="" hidden>Choose an option</option>
                                        <option v-for="(option, ix) in field.options" :key="`option-${ix}`" :value="option">
                                            {{ option }}
                                        </option>
                                    </select>
                                </div>
                                <div class="spacer s10"></div>
                            </div>

                            <div class="field-type" v-if="field.type == 'doodle'">
                                <div v-if="!fieldGroup.filled">
                                    <!-- <DoodlePad
                                        :fieldID="field.id"
                                        :refName="`doodle-${field.id}`"
                                        :dataUrl="answersCollection[field.id].answer"
                                        v-on:saveDoodle="saveDoodle"></DoodlePad> -->
                                    <DoodlePad
                                        :index="index"
                                        :fieldID="field.id"
                                        :refName="`doodle-${field.id}`"
                                        :dataUrl="answersCollection[field.id]?.answer || ''"
                                        @saveDoodle="saveDoodle" />
                                </div>
                                <div v-else class="saved-doodle">
                                    <div v-if="answersCollection[field.id].answer != ''" class="doodle">
                                        <img :src="answersCollection[field.id].answer" alt="" />
                                    </div>
                                    <div class="buttons">
                                        <span
                                            class="button is-warning"
                                            @click="
                                                fieldGroup.filled = false;
                                                answersCollection[field.id].answer = '';
                                            ">
                                            <font-awesome-icon :icon="answersCollection[field.id].answer != '' ? 'redo-alt' : 'pen'" /> &nbsp;{{
                                                answersCollection[field.id].answer != '' ? 'Draw again' : 'Click to Draw'
                                            }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="field-type" v-if="field.type == 'datetime'">
                                <datetime type="datetime" auto v-model="answersCollection[field.id].answer"></datetime>
                            </div>

                            <div class="field-type" v-if="field.type == 'riskmatrix'">
                                <div class="notification rating">
                                    <toggle-rating
                                        v-on:sendRatingData="getRatingData($event, field)"
                                        :savedRating="answersCollection[field.id].answer"></toggle-rating>
                                </div>
                            </div>

                            <div class="field-type" v-if="field.type == 'pindrop'">
                                <p>LAT: {{ location.lat }}</p>
                                <p>LONG: {{ location.long }}</p>
                                <div class="spacer s10"></div>
                                <div class="buttons">
                                    <div class="button is-primary" @click="getGeolocationInformation(field.id)">
                                        <span v-if="!gettingLocation">Get Device Location</span>
                                        <span v-else class="loading-spinner">
                                            <font-awesome-icon icon="spinner" class="fa-spin 3x" /> Locating...
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-section last">
                <div class="spacer s20"></div>
                <button
                    :disabled="reviewing"
                    class="button is-warning is-medium"
                    @click="
                        finalSave = true;
                        review();
                    ">
                    <font-awesome-icon icon="check-circle" /> &nbsp;Review and Submit
                </button>
            </div>
        </div>

        <div v-else>
            <hr />
            <div class="spacer s20"></div>
            <p v-if="formError != ''">{{ formError }}</p>
            <p v-else class="loading-spinner"><font-awesome-icon icon="spinner" class="fa-spin 3x" /> Creating a beautiful form...</p>
        </div>

        <div class="spacer s100"></div>

        <div class="modal modal-full-screen modal-fx-fadeInScale" v-bind:class="{ 'is-active': showAddCrew }">
            <div class="modal-background" @click="close"></div>
            <div class="modal-card">
                <header class="modal-card-head is-primary">
                    <p class="modal-card-title">Select Asset Crew</p>
                    <button class="delete" aria-label="hasSeenNotice" @click="close"></button>
                </header>

                <section class="modal-card-body left">
                    <div v-if="allVesselCrewIDs.length > 0">
                        <label>Add from the list of asset crew:</label>
                        <div class="spacer s10"></div>
                        <div class="checkbox-wrapper">
                            <div class="field" v-for="(crew, idx) in fullCrewList" :key="`crew-${idx}`">
                                <input class="is-checkradio" type="checkbox" :id="`crew-${idx}`" :value="crew.id" v-model="selectedCrewIDs" />
                                <label :for="`crew-${idx}`">{{ crew.name }}</label>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <p>No crew have been found for this asset.</p>
                    </div>

                    <div class="spacer s10"></div>
                </section>
                <footer class="modal-card-foot">
                    <button class="button" @click="close()">Cancel</button>
                    <button :disabled="selectedCrewIDs.length == 0" class="button is-primary" @click="addCrew()">Add Crew</button>
                </footer>
            </div>
        </div>

        <div class="modal modal-full-screen modal-fx-fadeInScale" v-bind:class="{ 'is-active': showDescription }">
            <div class="modal-background" @click="close"></div>
            <div class="modal-card">
                <header class="modal-card-head is-primary">
                    <p class="modal-card-title">Log Information</p>
                    <button class="delete" aria-label="hasSeenNotice" @click="close"></button>
                </header>
                <section class="modal-card-body description">
                    <div v-if="currentLogData.logDescription">
                        <div v-for="(line, idx) in currentLogData.logDescription.split('\n')" :key="`desc-${idx}`">{{ line }}</div>
                    </div>
                </section>
                <footer class="modal-card-foot">
                    <button class="button" @click="close()">Done</button>
                </footer>
            </div>
        </div>

        <div class="modal modal-full-screen modal-fx-fadeInScale" v-bind:class="{ 'is-active': showReviewModal }">
            <div class="modal-background" @click="close"></div>
            <div class="modal-card">
                <header class="modal-card-head is-primary">
                    <p class="modal-card-title">
                        {{
                            formSubmitted
                                ? 'Log Complete'
                                : incompleteFields.length > 0 && finalSave
                                ? 'Errors found'
                                : finalSave
                                ? 'Ready to Submit'
                                : 'Save for Later'
                        }}
                    </p>
                    <button class="delete" aria-label="hasSeenNotice" @click="close"></button>
                </header>

                <section class="modal-card-body">
                    <div v-if="formSubmitted">
                        <p class="green bold">Log submitted at: {{ today }}</p>
                        <div class="spacer s10"></div>
                        <p>You may close this window or reload the page below.</p>
                        <div class="spacer s20"></div>
                        <div class="buttons centered">
                            <button class="button is-primary is-medium" @click="close()">Reload Page</button>
                        </div>
                        <div class="spacer s10"></div>
                    </div>

                    <div v-else>
                        <div v-if="!reviewing">
                            <div v-if="reviewed">
                                <p class="green bold">Timestamp: {{ today }}</p>
                                <div v-if="isLoggedIn">
                                    <p>Name: {{ userData.username }}</p>
                                </div>
                                <div class="spacer s10"></div>
                                <div class="review-form">
                                    <div v-if="!isLoggedIn" class="review-field">
                                        <label class="label">Your name:</label>
                                        <input type="text" class="input" placeholder="Type your full name" v-model="formUserName" />
                                    </div>
                                    <div class="spacer s10"></div>

                                    <div v-if="allowWebFormEmail" class="review-field">
                                        <input class="is-checkradio normal" type="checkbox" id="localDifferent" v-model="sendEmail" />
                                        <label for="localDifferent">Email me a copy of this log</label>
                                        <div class="spacer s10"></div>
                                        <div v-if="sendEmail">
                                            <label class="label">Your email address:</label>
                                            <input type="text" class="input" placeholder="Type your email" v-model="formUserEmail" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="spacer s10"></div>
                                <p>{{ incompleteFields.length }} incomplete fields found. Please go back and check answers.</p>
                                <div class="spacer s10"></div>
                            </div>
                        </div>
                    </div>
                </section>
                <footer v-if="!formSubmitted" class="modal-card-foot">
                    <button class="button" @click="close()">Cancel</button>
                    <button
                        :disabled="(finalSave && incompleteFields.length > 0) || formUserName == '' || (sendEmail && !emailValid(formUserEmail))"
                        class="button is-primary"
                        @click="saveLog()">
                        Save Log
                    </button>
                </footer>
                <footer v-else class="modal-card-foot">
                    <button class="button is-primary" @click="close()">All Done!</button>
                </footer>
            </div>
        </div>

        <div class="modal modal-full-screen modal-fx-fadeInScale" v-bind:class="{ 'is-active': showOpenLogs }">
            <div class="modal-background" @click="close"></div>
            <div class="modal-card">
                <header class="modal-card-head is-primary">
                    <p class="modal-card-title">View Current Open Logs</p>
                    <button class="delete" aria-label="hasSeenNotice" @click="close"></button>
                </header>
                <section class="modal-card-body description">
                    <div v-for="(log, idx) in filteredOpenLogs" :key="`log-1-${idx}`" class="notification left" @click="toOpenLog(log)">
                        <div>
                            <div>
                                <font-awesome-icon icon="calendar-check" /> &nbsp;Started: {{ simpleDate(log.timestamp, true) }} ({{
                                    daysAgo(log.timestamp)
                                }})
                            </div>
                            <div><font-awesome-icon icon="user" /> &nbsp;Started By: {{ log.loggedBy }}</div>
                            <div v-if="log.keyFieldResult">
                                <div v-if="autoKeyUsed" class="bold"><font-awesome-icon icon="key" /> &nbsp;Key: {{ log.keyFieldResult }}</div>
                                <div v-else><font-awesome-icon icon="key" /> &nbsp;{{ keyFieldLabel }}: {{ log.keyFieldResult }}</div>
                            </div>
                        </div>
                        <div class="spacer s10"></div>
                    </div>
                    <div v-if="filteredOpenLogs.length == 0" class="spacer s10"></div>
                </section>
                <footer class="modal-card-foot">
                    <button class="button" @click="close()">Done</button>
                </footer>
            </div>
        </div>

        <div v-if="showOpenLogsButton" class="save-for-later open-logs" @click="showOpenLogs = true">
            <span class="save-icon"><font-awesome-icon icon="link" /></span>
            <span v-if="currentOpenLogs" class="save-text">
                {{ filteredOpenLogs.length }} {{ filteredOpenLogs.length == 1 ? 'Open Log' : 'Open Logs' }}
            </span>
        </div>

        <div
            v-if="formError == '' && !currentLogData.preventSaveForLater && !editingLog && !isHelper"
            class="save-for-later"
            @click="
                finalSave = false;
                review();
            ">
            <span class="save-icon"><font-awesome-icon icon="check" /></span>
            <span class="save-text">Save for Later</span>
        </div>

        <div class="spacer s100"></div>
        <div class="spacer s100"></div>
    </div>
</template>

<script>
import { db } from '../../main.js';
import {
    collection,
    query,
    increment,
    doc,
    onSnapshot,
    arrayUnion,
    getDoc,
    getDocs,
    orderBy,
    setDoc,
    addDoc,
    updateDoc,
    where,
    limit,
    writeBatch,
    Timestamp
} from 'firebase/firestore';
import NProgress from 'nprogress';
import { getFunctions, httpsCallable } from 'firebase/functions';

const aus_functions = getFunctions(undefined, 'australia-southeast1');
const submitPublicCustomLog = httpsCallable(aus_functions, 'asset_functions-submitPublicCustomLog');
const updatePublicCustomChecklist = httpsCallable(aus_functions, 'asset_functions-updatePublicCustomChecklist');
const uploadCustomLogImage = httpsCallable(aus_functions, 'asset_functions-uploadCustomLogImage');

import DoodlePad from '@/reusables/DoodlePad.vue';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import draggable from 'vuedraggable';

const functions = getFunctions();
// const customLogNotification = httpsCallable(functions, 'customLogNotification');
const triggerWebhooks = httpsCallable(functions, 'webhooks-triggerMultipleCustomLogWebhooks');
const loadAdminCrewData = httpsCallable(functions, 'loadAdminCrewData');
const customLogTrainingSchedule = httpsCallable(functions, 'customLogTrainingSchedule');
const updateManifestFromCustomWebForm = httpsCallable(functions, 'cf_passengers-updateManifestFromCustomWebForm');

const callAddAssetSystemLog = httpsCallable(functions, 'gen2_functions-addAssetSystemLog');
const callAddVesselRevision = httpsCallable(functions, 'gen2_functions-addVesselRevision_G2');

import ToggleRating from '@/reusables/ToggleRating.vue';

export default {
    mounted() {
        setTimeout(() => {
            this.loadListener();
            this.loadSavedLog();
        }, 500);
        this.getIPFromAmazon();
    },

    props: {
        allVesselCrewIDs: Array
    },

    components: {
        DoodlePad,
        draggable,
        vueDropzone: vue2Dropzone,
        ToggleRating
    },

    computed: {
        userData() {
            return this.$store.getters.getSubscriptionInfo;
        },
        currentVessel() {
            return this.$store.getters.getCurrentVessel;
        },
        currentVesselID() {
            return this.$store.getters.getCurrentVesselID;
        },
        currentLogMeta() {
            return this.$store.getters.getCurrentLogMeta;
        },
        currentLogData() {
            return this.$store.getters.getCurrentLogData;
        },
        linkedTrainingSchedules() {
            return this.currentLogData.linkedTrainingSchedules ? this.currentLogData.linkedTrainingSchedules : [];
        },
        incompleteFields() {
            return this.customFields
                .filter(
                    (m) =>
                        m.isRequired &&
                        (this.answersCollection[m.id].answer == '' ||
                            this.answersCollection[m.id].answer == null ||
                            this.answersCollection[m.id].answer.length == 0 ||
                            this.answersCollection[m.id].answer == 'Choose an option')
                )
                .map((n) => n.label);
        },
        user() {
            return this.$store.getters.getUser;
        },
        isLoggedIn() {
            return this.user && this.user.uid && this.user.uid != '';
        },
        today() {
            const dateOptions = {
                // timeZone: 'Australia/Sydney',
                month: 'short',
                day: 'numeric',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric'
            };
            return new Date().toLocaleDateString('en-US', dateOptions); // "June 1, 2019"
        },
        isEditing() {
            return this.currentLogMeta.vID && this.currentLogMeta.vID != '' ? true : false;
        },
        currentOpenLogs() {
            return this.currentLogData.openLogs ? this.currentLogData.openLogs : [];
        },
        showOpenLogsButton() {
            return this.filteredOpenLogs.length > 0 && this.currentLogMeta.vID == '';
        },
        keyFieldLabel() {
            let t = this.customFields ? this.customFields.filter((m) => m.id == this.currentLogData.keyFieldID)[0] : {};
            return t ? t.label : 'Key Field';
        },
        realAssetID() {
            return !this.isEditing ? this.currentLogMeta.aID : this.realVesselID;
        },
        filteredOpenLogs() {
            return this.currentOpenLogs.filter((m) => m.realAssetID == this.realAssetID);
        },
        autoKeyUsed() {
            return this.currentLogData.autoKeyUsed && this.currentLogData.autoKeyPrefix;
        },
        newAutoKeyResult() {
            return this.autoKeyUsed ? this.currentLogData.autoKeyPrefix + this.liveAutoKeyValue : '';
        },
        firstCrewPickerIDs() {
            let t = this.customFields.filter((m) => m.type == 'crew')[0];
            return t ? t.answer.map((n) => n.id) : [];
        },
        allowWebFormEmail() {
            return this.currentLogData.allowWebFormEmail ?? true;
        },
        isHelper() {
            return this.currentLogMeta.isHelper ?? false;
        }
    },

    data: function () {
        return {
            customFields: [],
            fieldGroups: [],
            loadingFields: true,
            noPromptFields: ['pindrop', 'datetime', 'dumbphoto', 'dumbtext'],
            hasSignature: false,
            showSignature: false,
            doodle: '',
            mounted: false,
            tempDate: new Date().toISOString(),
            reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,

            locationAPI: '0fef0f47abb54538b5a6778d9197ebc3',
            gettingLocation: false,
            location: {
                city: '',
                region: '',
                country: '',
                lat: '',
                long: ''
            },
            ipAddress: '',

            currentDoodleIndex: 6,
            update: false,
            reviewing: false,
            reviewed: true,
            finalAnswers: [],
            conditionalResponses: {},
            allIcons: {
                text: 'pen',
                paragraph: 'list-ul',
                checkboxes: 'check-square',
                doodle: 'pen',
                dropdown: 'list-ul',
                pindrop: 'map-marker',
                datetime: 'calendar-check',
                dumbtext: 'info-circle',
                upload: 'camera',
                dumbphoto: 'image',
                crew: 'users',
                riskmatrix: 'table',
                table: 'table',
                number: 'hashtag'
            },
            keyFieldResult: '',
            formUserName: '',
            sendEmail: false,
            formUserEmail: '',
            showReviewModal: false,
            formSubmitted: false,
            myUploads: [],
            dropzoneOptions: {
                url: '#',
                autoProcessQueue: false,
                thumbnailWidth: 150,
                thumbnailHeight: 150,
                addRemoveLinks: false,
                acceptedFiles: '.jpg, .jpeg, .png',
                dictDefaultMessage: `<p class='text-default'><i class='fa fa-cloud-upload mr-2'></i> Click here to add a photo</p><p class="form-text">Allowed Files: .jpg, jpeg, .png (Up to 4MB)</p>`,
                maxFilesize: 4,
                maxFiles: 3
            },
            selectedField: [],
            savedAnswers: [],
            savedAnswersMap: {},
            crewData: {},
            fullCrewList: [],
            showAddCrew: false,
            selectedCrewIDs: [],
            finalSave: false,
            formError: '',
            showDescription: false,
            showOpenLogs: false,
            errorMessage: '',
            hasError: false,
            realVesselID: '',
            savedAutoKey: '',
            liveAutoKeyValue: 0,

            option: 'none',
            scheduledTrips: [],
            selectedTrip: '',
            editingLog: false,
            editToken: '',
            newFormat: true,
            answersCollection: {},
            fieldsReady: false
        };
    },

    methods: {
        close() {
            // console.log('close');
            if (this.formSubmitted) {
                window.location.reload();
            } else {
                this.showReviewModal = false;
                this.reviewed = false;
                this.reviewing = false;
            }
            this.showAddCrew = false;
            this.selectedCrewIDs = [];
            this.showDescription = false;
            this.showOpenLogs = false;
            this.selectedTrip = '';
        },

        async loadListener() {
            // console.log(this.currentLogMeta);
            if (this.isHelper) return;
            const formColl = this.currentLogMeta.isFleet ? 'companies/' : 'vessels/';
            const unsub = onSnapshot(doc(db, formColl, this.currentLogMeta.vesselID, 'customChecklists', this.currentLogData.id), (doc) => {
                this.liveAutoKeyValue = doc.data().autoKeyValue ? doc.data().autoKeyValue : 0;
            });
        },

        // below method not called??
        async sanitiseAnswers(answers) {
            let sanitizedAnswers = [];
            await Promise.all(
                answers.map(async (answer) => {
                    // Sanitize each answer based on its type
                    let sanitizedAnswer = { ...answer };
                    sanitizedAnswer.localAnswer = this.sanitizeSingleAnswer(sanitizedAnswer.type, sanitizedAnswer.answer);
                    sanitizedAnswers.push(sanitizedAnswer);
                    this.savedAnswersMap[sanitizedAnswer.id] = sanitizedAnswer.localAnswer;
                })
            );

            return sanitizedAnswers;
        },

        sanitizeSingleAnswer(type, answer) {
            const asArray = (v) => (Array.isArray(v) ? v : v == null ? [] : [v]);

            // Treat placeholder arrays as empty arrays
            const emptyIfPlaceholderArray = (arr) => {
                if (!Array.isArray(arr)) return arr;
                if (arr.length === 0) return arr;
                if (arr.length === 1) {
                    const v = arr[0];
                    if (v === '' || v === 'Choose an option' || v == null) return [];
                }
                return arr;
            };

            switch (type) {
                case 'text':
                case 'customtext':
                case 'paragraph':
                case 'riskmatrix':
                case 'upload':
                    return Array.isArray(answer) ? answer.filter(Boolean) : [];

                case 'doodle':
                    return answer === 'Choose an option' || answer === '' ? '' : answer;

                // dropdown should be a string
                case 'dropdown':
                    return Array.isArray(answer) ? answer[0] ?? '' : answer ?? '';

                case 'checkboxes':
                    return Array.isArray(answer) ? answer : [];

                case 'number':
                    return Array.isArray(answer) ? answer : [answer ?? ''];

                case 'pindrop': {
                    const latitude = Array.isArray(answer) ? answer[0] ?? '' : '';
                    const longitude = Array.isArray(answer) ? answer[1] ?? '' : '';
                    const what3words = Array.isArray(answer) ? answer[2] ?? '' : '';
                    const url =
                        'https://maps.googleapis.com/maps/api/staticmap?size=600x600&zoom=7&center=' +
                        latitude +
                        ',' +
                        longitude +
                        '&scale=1&format=png&maptype=roadmap&key=AIzaSyAWTjw84LiSreWuruKtazxm7jbeK4g0k9U&markers=color:red%7C' +
                        latitude +
                        ',' +
                        longitude +
                        '&markers=color:red%7CMemphis,TN';

                    // return { image: url, latitude, longitude, what3words };
                    return { latitude, longitude, what3words };
                }

                // case 'crew':
                //     return Array.isArray(answer) ? answer : [];
                case 'crew': {
                    const arr = emptyIfPlaceholderArray(asArray(answer));
                    return arr.filter((x) => !(typeof x === 'string' && x.trim() === ''));
                }

                case 'datetime':
                    // return answer?.toDate ? answer.toDate() : answer;
                    return typeof answer === 'string' ? answer : answer?.toDate ? answer.toDate().toISOString() : '';

                case 'dumbtext':
                case 'dumbphoto':
                default:
                    return answer ?? '';
            }
        },

        async loadNewSavedAnswers() {
            // console.log('t1', this.currentLogMeta.aID, '2', this.currentLogMeta.vID);
            const ref = collection(db, 'vessels', this.currentLogMeta.aID, 'customLogs', this.currentLogMeta.vID, 'answers');
            // console.log('ref', ref);
            const snap = await getDocs(ref);

            for (const d of snap.docs) {
                this.$set(this.answersCollection, d.id, d.data()); // <-- Vue2 reactive
            }
        },

        async loadSavedLog() {
            // console.log('Loading new saved answers first, regardless if they exist');
            // console.log('Now loading saved log data...');
            if (this.currentLogMeta.vID == '') {
                // console.log('No saved log to load, creating new log instance...');
                await this.loadCustomFields();
            } else {
                if (!this.isHelper) await this.loadNewSavedAnswers();

                // console.log('Loading saved log for vID:', this.currentLogMeta.vID);
                // const coll = this.currentLogMeta.isFleet ? 'companies/' : 'vessels/';
                const coll = this.currentLogMeta.isFleet ? 'vessels/' : 'vessels/';
                // const docRef = doc(db, coll + this.currentLogMeta.vesselID + '/customLogs', this.currentLogMeta.vID);
                const docRef = doc(db, coll + this.currentLogMeta.aID + '/customLogs', this.currentLogMeta.vID);
                // console.log('coll, DocRef:', coll, docRef);
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    let data = docSnap.data();
                    let answers = data.customFieldAnswers ?? [];
                    // this.savedAnswers = data.customFieldAnswers ? data.customFieldAnswers : [];
                    this.realVesselID = data.realVesselID ? data.realVesselID : '';
                    this.savedAutoKey = data.keyFieldResult ? data.keyFieldResult : '';
                    this.editToken = data.editToken ? data.editToken : '';
                    this.editingLog = this.editToken != '' ? true : false;
                    // this.savedAnswersMap = this.savedAnswers.reduce((acc, a) => ({ ...acc, [a.id]: a.answer }), {});
                    let status = data.status ? data.status : 'completed';
                    let newFormat = data.newFormat ?? false;
                    if (status == 'open' || status == 'active' || this.editingLog) {
                        // proceed if saved log still active
                        await this.loadCustomFields();
                    } else {
                        this.formError = 'This log has already been completed and is no longer editable.';
                    }
                } else {
                    this.formError = 'This log does not exist.';
                }
            }
            // setTimeout(() => {
            //     this.fieldsReady = true;
            //     this.loadingFields = false;
            // }, 1500);
            this.loadCrewData();
        },

        defaultAnswerFor(type) {
            if (type === 'checkboxes') return [];
            if (type === 'upload') return []; // prefer this to [""] so the dropzone uploader displays
            if (type === 'number') return ['']; // critical for v-model answer[0]
            if (['text', 'customtext', 'paragraph', 'crew', 'riskmatrix', 'upload', 'dropdown'].includes(type)) {
                return [''];
            }
            return '';
        },

        async loadCustomFields() {
            const formColl = this.currentLogMeta.isFleet ? 'companies' : 'vessels';
            const ref = this.isHelper
                ? collection(db, 'helperCustomLogs', this.currentLogMeta.logID, 'customFields')
                : collection(db, formColl, this.currentLogMeta.vesselID, 'customChecklists', this.currentLogMeta.logID, 'customFields');
            const snap = await getDocs(query(ref, orderBy('index')));

            // reset (Vue2-safe)
            this.customFields = [];
            this.fieldGroups = [];
            this.answers = [];
            this.conditionalResponses = {}; // ok as whole-object replace

            let subField = [];

            // ensure reactive root objects exist (Vue2-safe)
            if (!this.answersCollection || typeof this.answersCollection !== 'object' || Array.isArray(this.answersCollection)) {
                this.$set(this, 'answersCollection', {});
            }

            const getSaved = (id, type) => {
                // answersCollection items are {type, answer}
                const savedObj = this.answersCollection?.[id] ?? this.savedAnswersMap?.[id];
                const rawAnswer = savedObj?.answer ?? '';
                return this.sanitizeSingleAnswer(type, rawAnswer);
            };

            const hydrateTable = (data, answer) => {
                if (!Array.isArray(data.tableData) || !Array.isArray(answer)) return;

                data.tableData.forEach((cell, i) => {
                    if (answer[i] === undefined || answer[i] === null) return;

                    if (cell.type === 'text') {
                        cell.value = answer[i] === 'false' ? '' : String(answer[i] ?? '');
                    } else if (cell.type === 'check') {
                        cell.value = answer[i] === true || answer[i] === 'true';
                    }
                });
            };

            const ensureAnswerShape = (type, data, value) => {
                // number uses answer[0]
                if (type === 'number') {
                    if (Array.isArray(value)) return value.length ? value : [''];
                    return [value ?? ''];
                }

                // table uses answer[cellIndex]
                if (type === 'table') {
                    const rows = Number(data.tableRows ?? 0);
                    const cols = Number(data.tableCols ?? 0);
                    const cellCount = rows * cols;

                    const base = Array.from({ length: cellCount }, (_, i) => {
                        const cell = Array.isArray(data.tableData) ? data.tableData[i] : null;
                        if (cell?.type === 'check') {
                            if (cell?.value === true) return true;
                            if (cell?.value === 'true') return true;
                            return false;
                        }
                        return cell?.value ?? '';
                    });

                    if (!Array.isArray(value)) return base;

                    for (let i = 0; i < Math.min(value.length, base.length); i++) {
                        const cell = Array.isArray(data.tableData) ? data.tableData[i] : null;
                        if (cell?.type === 'check') {
                            base[i] = value[i] === true || value[i] === 'true';
                        } else {
                            base[i] = value[i] === undefined || value[i] === null ? base[i] : value[i];
                        }
                    }

                    return base;
                }

                // ✅ critical: do NOT destroy other field answers
                return value;
            };

            for (let idx = 0; idx < snap.docs.length; idx++) {
                const d = snap.docs[idx];
                const data = d.data();
                const type = data.type;
                const id = d.id;

                data.id = id;
                data.answerCount = 1;

                const answer = getSaved(id, type);

                // --- Vue2 reactivity: ALWAYS use $set for dynamic keys / nested keys ---
                if (!this.answersCollection[id]) {
                    this.$set(this.answersCollection, id, {
                        type,
                        answer: type === 'checkboxes' ? [] : type === 'dropdown' ? '' : this.defaultAnswerFor(type)
                    });
                }

                // coerce wrong shapes (and set via $set)
                if (type === 'checkboxes' && !Array.isArray(this.answersCollection[id].answer)) {
                    this.$set(this.answersCollection[id], 'answer', []);
                }
                if (type === 'dropdown' && Array.isArray(this.answersCollection[id].answer)) {
                    this.$set(this.answersCollection[id], 'answer', this.answersCollection[id].answer[0] ?? '');
                }

                // write latest values (Vue2-safe)
                this.$set(this.answersCollection[id], 'type', type);
                // this.$set(this.answersCollection[id], 'answer', answer);
                const shapedAnswer = ensureAnswerShape(type, data, answer);
                this.$set(this.answersCollection[id], 'answer', shapedAnswer);

                // use the reactive source as the field answer (so template stays in sync)
                data.answer = this.answersCollection[id].answer;
                if (type === 'table') hydrateTable(data, data.answer);

                data.fieldConditions = data.fieldConditions ?? [];
                data.isRequired = data.isRequired ?? false;
                data.numVal = data.numVal ?? 0;
                data.filled = true;

                subField.push(data);
                this.customFields.push(data);

                // conditionalResponses init (Vue2-safe for dynamic key)
                this.$set(this.conditionalResponses, id, []);

                const next = snap.docs[idx + 1];
                const isLast = idx + 1 === snap.docs.length;
                const nextIsNotChild = next ? !next.data().isAChild : true;

                if (isLast || nextIsNotChild) {
                    this.fieldGroups.push({ subField, filled: true });
                    subField = [];
                }
            }

            // this.mounted = true;
            // this.fieldsReady = true;
            // this.loadingFields = false;
            this.$nextTick(() => {
                this.mounted = true;
                this.fieldsReady = true;
                this.loadingFields = false;
            });
        },

        isFieldRequiredMissing(field) {
            const a = this.answersCollection?.[field.id]?.answer;

            // const empty = a == null || (Array.isArray(a) ? a.length === 0 || a[0] === '' : a === '') || a === 'Choose an option';
            const empty = a == null || (Array.isArray(a) ? a.length === 0 || a[0] === '' : a === '');

            return !!field.isRequired && empty;
        },

        getIndex(rowIndex, colIndex, tableCols) {
            // Ensure tableCols is a number and at least 1 to prevent division by zero or NaN results
            const numCols = Math.max(1, tableCols);
            return rowIndex * numCols + colIndex;
        },

        getRatingData(result, field) {
            this.answersCollection[field.id].answer = result;
            field.answer = [result];
            this.conditionalResponses[field.id] = this.answersCollection[field.id].answer;
        },

        simpleDate(sentDate, full) {
            if (!sentDate) return '';

            const options = full
                ? { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric' }
                : { month: 'short', day: 'numeric', year: 'numeric' };

            const date = sentDate instanceof Date ? sentDate : typeof sentDate.toDate === 'function' ? sentDate.toDate() : null;

            return date ? date.toLocaleDateString('en-US', options) : '';
        },

        daysAgo(d) {
            // Normalize Firestore Timestamp / JS Date / {seconds,nanoseconds} into a JS Date
            const date =
                d instanceof Date
                    ? d
                    : typeof d?.toDate === 'function'
                    ? d.toDate()
                    : typeof d?.seconds === 'number'
                    ? new Date(d.seconds * 1000)
                    : null;

            if (!date || isNaN(date.getTime())) return '';

            const diff = Date.now() - date.getTime();
            const days = Math.round(diff / (1000 * 3600 * 24));

            return days === 0 ? 'today' : days === 1 ? '1 day ago' : `${days} days ago`;
        },

        toOpenLog(log) {
            let assetID = log.realAssetID && log.realAssetID != '' ? log.realAssetID : this.currentVesselID;
            let targetUrl = 'https://go.offshoresms.com.au/vessel-logs?x=' + this.currentLogData.webLink + '&a=' + assetID + '&v=' + log.id;
            window.open(targetUrl, '_blank');
        },

        emailValid(email) {
            return this.reg.test(email) && email.includes('@');
        },

        async afterComplete(file, fieldID) {
            // console.log('afterComplete', file, fieldID, this.realAssetID);
            NProgress.start();
            try {
                const reader = new FileReader();
                reader.onload = async () => {
                    try {
                        const result = await uploadCustomLogImage({
                            assetID: this.realAssetID,
                            imageBase64: reader.result
                        });
                        if (result.data && result.data.downloadURL) {
                            this.answersCollection[fieldID].answer.push(result.data.downloadURL);
                        }
                    } catch (error) {
                        console.error('Image upload failed:', error);
                    }
                    NProgress.done();
                };
                reader.readAsDataURL(file);
            } catch (error) {
                console.error('Image read failed:', error);
                NProgress.done();
            }
        },

        deleteImage(field, index) {
            // console.log('delete');
            this.imageChanged = true;
            this.myUploads.splice(index, 1);
            field.splice(index, 1);
        },

        orderChanged() {
            // drag = false;
            this.imageChanged = true;
        },

        setResponse(fieldID) {
            this.conditionalResponses[fieldID] = this.answersCollection[fieldID].answer;
        },

        async addCrew() {
            NProgress.start();
            let currentIDs = this.selectedField.answer.map((m) => m.id);
            await Promise.all(
                this.selectedCrewIDs.map((id) => {
                    if (!currentIDs.includes(id)) {
                        this.selectedField.answer.push(this.crewData[id]);
                    }
                })
            );
            this.showAddCrew = false;
            this.close();
            NProgress.done();
        },

        sortedByName(arr) {
            function compare(a, b) {
                return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
            }
            return arr.sort(compare);
        },

        async loadCrewData() {
            await loadAdminCrewData({
                allVesselCrewIDs: this.allVesselCrewIDs
            })
                .then((result) => {
                    let success = result.data.message == 'Success';
                    // console.log('success', success);
                    if (result.data.crewArray && result.data.crewMap) {
                        // console.log('result.data', result.data);
                        this.crewData = result.data.crewMap;
                        this.fullCrewList = this.sortedByName(result.data.crewArray);
                    } else {
                        this.hasError = true;
                        this.errorMessage = 'There was an error validating your code, sorry. Please click Get Help below.';
                    }
                })
                .catch((error) => {
                    // console.log('Error loading crew', error.text);
                });
        },

        getAvatar(crewName) {
            if (crewName == undefined || crewName == '') return 'NN';
            let parts = crewName.split(' ');
            let initials = '';
            if (parts.length == 1) return parts[0][0];
            for (let i = 0; i < 2; i++) {
                if (parts[i] != undefined && parts[i].length > 0 && parts[i] !== '') {
                    initials += parts[i][0];
                }
            }
            return initials;
        },

        removeCrew(inx, index, crewID, fieldID) {
            // this.answers[tempIndex] = this.answers[tempIndex].filter((m) => m.id != crewID);
            // this.answersCollection[fieldID] = this.answersCollection[fieldID].answer.filter((m) => m.id != crewID);
            this.$set(
                this.answersCollection[fieldID],
                'answer',
                this.answersCollection[fieldID].answer.filter((m) => m.id != crewID)
            );
            // console.log('X', this.answers[tempIndex]);
            // console.log(inx, index, this.fieldGroups[inx].subField[index].answer);
            let answers = this.fieldGroups[inx].subField[index].answer.filter((m) => m.id != crewID);
            // console.log('answers', answers);
            this.fieldGroups[inx].subField[index].answer = answers;
        },

        showCustomField(field) {
            if (!field.fieldConditions || field.fieldConditions.length === 0) return true;

            const getSourceVals = (sourceId) => {
                const v = this.answersCollection?.[sourceId]?.answer;

                // normalise so we can always use includes()
                if (v == null) return [];
                // if (Array.isArray(v)) return v;
                if (Array.isArray(v)) return v.map((x) => (x == null ? '' : String(x)));
                return [String(v)];
            };

            const matches = (cond) => getSourceVals(cond.sourceFieldID).includes(cond.sourceOptionValue);

            return field.conditionType === 'ANY' ? field.fieldConditions.some(matches) : field.fieldConditions.every(matches);
        },

        async getGeolocationInformation(fieldID) {
            this.location.lat = '';
            this.location.long = '';
            this.gettingLocation = true;
            this.answersCollection[fieldID].answer = ['', '', ''];
            const API_URL = 'https://ipgeolocation.abstractapi.com/v1/?api_key=' + this.locationAPI;
            const apiResponse = await fetch(API_URL);
            const data = await apiResponse.json();
            const { city, country, region, latitude, longitude } = data;
            // console.log(data);
            setTimeout(() => {
                this.location.city = city;
                this.location.region = region;
                this.location.lat = latitude.toString();
                this.location.long = longitude.toString();
                this.answersCollection[fieldID].answer = [latitude.toString(), longitude.toString(), ''];
                this.gettingLocation = false;
            }, 500);
        },

        truncate(string, limit) {
            // console.log(string,limit);
            if (string == undefined || string == '') return '';
            return string.length > limit ? string.slice(0, limit) + '...' : string;
        },

        pluralise(length) {
            return length == 1 ? '' : 's';
        },

        isNumber($evt, maxLength, allowDecimal = false) {
            var charCode = $evt.which ? $evt.which : $evt.keyCode;
            var inputValue = $evt.target.value;

            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                if (allowDecimal && charCode === 46) {
                    // Do nothing
                } else {
                    $evt.preventDefault();
                    return;
                }
            }

            if (inputValue.length >= maxLength) {
                $evt.preventDefault();
            }
        },

        addTextField(field) {
            if (field.answerCount > 9) return;
            if (
                field.answerCount == 1 &&
                (this.answersCollection[field.id].answer[0] == null || this.answersCollection[field.id].answer[0] == undefined)
            )
                this.answersCollection[field.id].answer[0] = '';
            this.answersCollection[field.id].answer.push('');
            field.answerCount++;
        },

        removeTextField(field, idx) {
            this.answersCollection[field.id].answer.splice(idx - 1, 1);
            field.answerCount--;
        },

        // saveDoodle(result) {
        //     this.answersCollection[result.fieldID].answer = result.doodle;
        // },
        saveDoodle(result) {
            const id = result.fieldID;
            if (!id) return;

            if (!this.answersCollection || typeof this.answersCollection !== 'object') {
                this.$set(this, 'answersCollection', {});
            }

            if (!this.answersCollection[id]) {
                this.$set(this.answersCollection, id, { type: 'doodle', answer: '' });
            }

            this.$set(this.answersCollection[id], 'answer', result.doodle ?? '');
        },

        // getKeyFieldAnswer() {
        //     let self = this;
        //     if (this.autoKeyUsed) {
        //         return this.isEditing ? this.savedAutoKey : this.newAutoKeyResult;
        //     } else {
        //         if (!this.currentLogData.keyFieldID || this.currentLogData.keyFieldID == '' || this.currentLogData.keyFieldID == undefined) {
        //             return '';
        //         } else {
        //             let keyAnswer = this.finalAnswers.filter((m) => m.id == this.currentLogData.keyFieldID)[0];
        //             return keyAnswer && typeof keyAnswer.answer === 'string'
        //                 ? self.truncate(keyAnswer.answer ? keyAnswer.answer : '', 30)
        //                 : self.truncate(keyAnswer.answer[0], 30);
        //         }
        //     }
        // },

        // getKeyFieldAnswer() {
        //     // Auto-key path
        //     if (this.autoKeyUsed) {
        //         return this.isEditing ? this.savedAutoKey ?? '' : this.newAutoKeyResult ?? '';
        //     }

        //     const keyFieldID = this.currentLogData?.keyFieldID;
        //     if (!keyFieldID) return '';

        //     // Find the answer safely (prefer find over filter[0])
        //     const keyAnswer = Array.isArray(this.finalAnswers) ? this.finalAnswers.find((m) => m?.id == keyFieldID) : null;

        //     if (!keyAnswer) return '';

        //     const raw = keyAnswer.answer;

        //     // Decide what string to display
        //     let text = '';

        //     if (typeof raw === 'string') {
        //         text = raw;
        //     } else if (Array.isArray(raw)) {
        //         // handle [], [''], [null], etc.
        //         const first = raw.find((v) => typeof v === 'string' && v.trim() !== '');
        //         text = first ?? '';
        //     } else if (raw != null) {
        //         // last resort: stringify odd types (number, object) safely
        //         text = String(raw);
        //     }

        //     return this.truncate(text, 30);
        // },

        getKeyFieldAnswer() {
            const methodRaw = this.currentLogData?.keyFieldMethod;
            const keyFieldMethod = (typeof methodRaw === 'string' ? methodRaw : 'none').toLowerCase();

            // small helper so we never crash on weird inputs
            const safeTruncate = (val, n) => {
                const s = val == null ? '' : String(val);
                try {
                    return typeof this.truncate === 'function' ? this.truncate(s, n) : s.slice(0, n);
                } catch (e) {
                    return s.slice(0, n);
                }
            };

            // Normalise auto key values
            const savedAutoKey = this.savedAutoKey ?? '';
            const newAutoKeyResult = this.newAutoKeyResult ?? '';

            if (keyFieldMethod === 'none') return '';

            if (keyFieldMethod === 'remote') {
                // If "remote" is always saved, return as-is (optionally truncate here too if UI expects it)
                return savedAutoKey;
            }

            if (keyFieldMethod === 'auto') {
                return this.isEditing ? savedAutoKey : newAutoKeyResult;
            }

            if (keyFieldMethod === 'existing') {
                const keyFieldID = this.currentLogData?.keyFieldID;
                if (!keyFieldID) return '';

                const fields = Array.isArray(this.customFields) ? this.customFields : [];
                const fieldIndex = fields.findIndex((f) => f.id === keyFieldID);
                if (fieldIndex === -1) return '';

                const raw = this.finalAnswers[fieldIndex];
                if (raw == null) return '';

                let text = '';
                if (typeof raw === 'string') {
                    text = raw;
                } else if (Array.isArray(raw)) {
                    // prefer first non-empty string; fallback to first defined item
                    const firstStr = raw.find((v) => typeof v === 'string' && v.trim() !== '');
                    text = firstStr ?? (raw.find((v) => v != null) != null ? String(raw.find((v) => v != null)) : '');
                } else if (raw != null) {
                    text = String(raw);
                }

                return safeTruncate(text, 30);
            }

            // Unknown method → safe fallback
            return '';
        },

        async review() {
            NProgress.start();

            if (this.isHelper) {
                setTimeout(() => {
                    this.formSubmitted = true;
                    NProgress.done();
                }, 500);
                window.location.reload();
                return;
            }

            this.formUserName = this.isLoggedIn ? this.userData.username : this.formUserName;
            this.finalAnswers = [];
            this.reviewed = false;
            this.reviewing = this.finalSave;

            this.customFields.forEach((field, index) => {
                let answer = this.answersCollection[field.id].answer;
                field.answer = answer;
                this.finalAnswers.push(answer);
            });

            this.keyFieldResult = this.getKeyFieldAnswer();
            setTimeout(() => {
                this.reviewing = false;
                this.reviewed = !this.finalSave ? true : this.incompleteFields.length == 0;
                this.showReviewModal = true;
                NProgress.done();
            }, 500);
        },

        async cleanAnswers() {
            this.finalAnswers.forEach((answer) => {
                if (answer.type == 'datetime') answer.answer = new Date(answer.answer);
                if (answer.type == 'number' && answer.answer.length == 0) answer.answer = [''];
                if (answer.type == 'table') {
                    // answer.answer = answer.tableData.map((v) => (v.value == true ? 'true' : v.value == false ? 'false' : v.value));
                    answer.answer = answer.tableData.map((v) =>
                        v.type == 'text' ? v.value : v.value == true ? 'true' : v.value == false ? '' : v.value
                    );
                }
            });
        },

        // async updateOpenLogs(finalLogID) {
        //     let temp = [...this.currentLogData.openLogs];
        //     await Promise.all(
        //         temp.map(async (log) => {
        //             if (log.id == finalLogID) {
        //                 log.keyFieldResult = this.keyFieldResult;
        //             }
        //         })
        //     );
        //     return temp;
        // },
        async updateOpenLogs(finalLogID) {
            // llop through current open logs and injext the latest keyFieldResult into the matching log ID
            const openLogs = Array.isArray(this.currentLogData?.openLogs) ? this.currentLogData.openLogs : [];
            return openLogs.map((log) => (log?.id === finalLogID ? { ...log, keyFieldResult: this.keyFieldResult ?? '' } : log));
        },

        async getIPFromAmazon() {
            fetch('https://checkip.amazonaws.com/')
                .then((res) => res.text())
                .then((data) => {
                    // console.log('AWS', data);
                    this.ipAddress = data;
                });
        },

        buildAnswersPayload() {
            const answers = {};
            for (const [id, entry] of Object.entries(this.answersCollection)) {
                if (!entry) continue;
                let { type, answer } = entry;

                // Normalise datetime to ISO string for JSON serialisation
                if (type === 'datetime') {
                    if (answer instanceof Date) {
                        answer = answer.toISOString();
                    } else if (typeof answer === 'string') {
                        const d = new Date(answer);
                        if (!isNaN(d)) answer = d.toISOString();
                    }
                }

                if (answer == null || (Array.isArray(answer) && answer.length === 0) || (typeof answer === 'string' && answer.trim() === '')) {
                    continue;
                }

                answers[id] = { type, answer };
            }
            return answers;
        },

        async saveLog() {
            NProgress.start();
            this.formUserName = this.isLoggedIn ? this.userData.username : this.formUserName;
            let self = this;
            let checklistName = this.currentLogData.checklistName ? this.currentLogData.checklistName : '';
            let notifyEmails = this.currentLogData.notifyEmails ? this.currentLogData.notifyEmails : [];
            if (this.sendEmail) notifyEmails.push(this.formUserEmail);

            await this.cleanAnswers();

            let finalLogID;
            let newDocRef;
            if (this.isEditing) {
                finalLogID = this.currentLogMeta.vID;
            } else {
                newDocRef = doc(collection(db, 'vessels', this.currentLogMeta.aID, 'customLogs'));
                finalLogID = newDocRef.id;
            }

            // let finalLogID = this.currentLogMeta.vID ? this.currentLogMeta.vID : '';
            let isFleetLog = this.currentLogMeta['isFleet'] ? this.currentLogMeta['isFleet'] : false;
            let realVesselID = this.currentLogMeta.aID ? this.currentLogMeta.aID : this.realVesselID != '' ? this.realVesselID : this.realAssetID;

            var newLogData = {
                isFleet: isFleetLog,
                vesselName: this.currentLogMeta['vesselName'],
                realVesselName:
                    this.currentVessel.vesselName && this.currentVessel.vesselName != ''
                        ? this.currentVessel.vesselName
                        : this.currentLogMeta['vesselName'],
                realVesselID: realVesselID,
                vesselID: this.currentLogMeta['vesselID'],
                selectedItems: [],
                notes: '',
                location: 'Not set',
                lastUpdateBy: this.formUserName,
                lastUpdateTimestamp: new Date(),
                customChecklistID: this.currentLogMeta['logID'],
                customChecklistName: checklistName,
                lastLogStatus: 'complete',
                lastLogComplete: true,
                keyFieldResult: this.keyFieldResult,
                status: this.finalSave ? 'complete' : 'open',
                isFleetCopy: isFleetLog,
                linksToManifest: this.currentLogData.linksToManifest && this.currentLogData.linksToManifest == true,
                editToken: '',
                newFormat: true,
                notifyEmails: notifyEmails
            };

            const formColl = this.currentLogMeta.isFleet ? 'companies' : 'vessels';

            if (this.isEditing) {
                await submitPublicCustomLog({ action: 'update', assetID: this.currentLogMeta.aID, logID: finalLogID, logData: newLogData });

                const openLogs = this.currentLogData?.openLogs;
                if (Array.isArray(openLogs) && openLogs.length) {
                    const updatedOpenLogs = this.finalSave ? openLogs.filter((m) => m?.id !== finalLogID) : await this.updateOpenLogs(finalLogID);
                    await updatePublicCustomChecklist({
                        parentCollection: formColl,
                        parentID: this.currentLogMeta.vesselID,
                        checklistID: this.currentLogMeta.logID,
                        updateData: { openLogs: updatedOpenLogs }
                    });
                }
            } else {
                newLogData.timestamp = new Date();
                newLogData.logTimestamp = new Date();
                newLogData.postedBy = this.formUserName;

                await submitPublicCustomLog({ action: 'create', assetID: this.currentLogMeta.aID, logID: finalLogID, logData: newLogData });

                if (!this.finalSave) {
                    let logData = {
                        id: finalLogID,
                        timestamp: new Date(),
                        loggedBy: this.formUserName,
                        keyFieldResult: this.keyFieldResult,
                        realAssetID: realVesselID
                    };
                    await updatePublicCustomChecklist({
                        parentCollection: formColl,
                        parentID: this.currentLogMeta['vesselID'],
                        checklistID: this.currentLogMeta['logID'],
                        updateData: { openLogs: { __arrayUnion__: logData } }
                    });
                }

                // save trip manifest formSubmission
                if (this.currentLogData.linksToManifest && this.currentLogData.linksToManifest == true) {
                    try {
                        updateManifestFromCustomWebForm({
                            assetID: this.realAssetID,
                            tripID: this.currentLogData.tripID,
                            archived: false,
                            isFleetLog: this.currentLogMeta.isFleet ?? false,
                            fleetID: this.currentLogMeta['vesselID'] ?? '',
                            logID: finalLogID ?? '',
                            passengerID: this.currentLogData.passengerID ?? '',
                            passengerName: this.currentLogData.passengerName ?? '',
                            checklistName: checklistName ?? '',
                            checklistID: this.currentLogMeta['logID'] ?? '',
                            timestamp: new Date(),
                            appUserName: this.formUserName ?? '',
                            appUserID: ''
                        });
                    } catch (error) {
                        // console.log('Error saving manifest form submission', error);
                    }
                }

                await updatePublicCustomChecklist({
                    parentCollection: formColl,
                    parentID: this.currentLogMeta['vesselID'],
                    checklistID: this.currentLogMeta['logID'],
                    updateData: { autoKeyValue: '__increment__' }
                });
            }

            // save answers via cloud function
            const answersPayload = this.buildAnswersPayload();

            if (this.finalSave && this.linkedTrainingSchedules.length > 0) {
                if (this.firstCrewPickerIDs && this.firstCrewPickerIDs.length > 0) {
                    customLogTrainingSchedule({
                        linkedTrainingSchedules: this.linkedTrainingSchedules,
                        assetID: realVesselID,
                        assetName: this.currentLogMeta['vesselName'],
                        userName: this.formUserName,
                        crewIDs: this.firstCrewPickerIDs,
                        customLogName: checklistName
                    });
                }
            }

            if (this.currentLogData.webhooksEnabled && this.currentLogData.webhookIDs?.length > 0) {
                triggerWebhooks({
                    logID: finalLogID,
                    isFleet: this.currentLogMeta.isFleet,
                    // topID: this.currentLogMeta['vesselID'],
                    topID: this.currentLogMeta.aID ?? this.realAssetID,
                    webhookIDs: this.currentLogData.webhookIDs,
                    action: this.finalSave ? 'completeLog' : 'saveForLater'
                });
            }

            let prefix = this.isEditing ? 'Existing log edited ' : 'New log created ';
            let suffix = this.finalSave ? 'and completed (final submission).' : 'and saved for later.';
            let timelineEntry = {
                timestamp: new Date(),
                entry: prefix + suffix,
                loggedBy: this.formUserName ?? '',
                loggedByID: '',
                method: 'web'
            };
            const timelineLogID = this.isEditing ? this.currentLogMeta.vID : finalLogID;
            await submitPublicCustomLog({
                action: 'timeline',
                assetID: this.currentLogMeta.aID,
                logID: timelineLogID,
                timelineEntry,
                answers: answersPayload
            });

            callAddAssetSystemLog({
                assetName: this.currentLogMeta['vesselName'],
                assetID: this.realAssetID,
                userName: this.formUserName ?? '',
                userID: '',
                details: 'Custom form [' + checklistName + '] ' + (this.isEditing ? 'saved for later' : 'completed') + ' in go.offshoresms.com.au',
                logType: 'customLog',
                logID: finalLogID ?? '',
                ipAddress: this.ipAddress ?? '',
                os: '',
                platform: 'web go',
                version: '',
                build: '',
                browserType: '',
                browserVersion: '',
                appUpdated: false,
                sourceScreen: 'CustomLogsSinglePage'
            });

            callAddVesselRevision({
                // vesselID: self.currentLogMeta['vesselID'],
                // logID: finalLogID,
                // userName: self.formUserName
                vesselName: this.currentLogMeta['vesselName'],
                vesselID: this.realAssetID,
                userName: this.formUserName ?? '',
                userID: '',
                revisionDetails:
                    (this.isEditing ? 'Active custom' : 'Custom') +
                    ' form [' +
                    checklistName +
                    '] ' +
                    (this.isEditing ? 'saved for later' : 'completed'),
                logType: 'customLog',
                logID: finalLogID ?? '',
                imageUrls: [],
                customFormName: checklistName ?? ''
            });

            setTimeout(() => {
                this.formSubmitted = true;
                NProgress.done();
            }, 500);
        }
    }
};
</script>

<style lang="scss" scoped>
h1 {
    color: #444;
    margin-bottom: 5px;
}
.container {
    max-width: 1000px !important;
    padding: 1rem 20px !important;
}
.header-spacer {
    height: 40px;
}
.checkbox-wrapper {
    text-align: left;
    .field {
        text-indent: -2rem;
        margin-left: 2em;
    }
}
.modal-card-body {
    &.left {
        text-align: left;
    }
}
.modal {
    .modal-card {
        max-height: 80%;
        max-height: 80vh;
    }
    .modal-card-title {
        font-size: 1.2rem;
        font-weight: bold;
    }
}

.trip-info {
    margin-top: 10px;
    color: orange;
    font-weight: bold;
}
.form-section {
    margin-bottom: 15px;
    // padding-bottom: 15px;
    // border-bottom: 1px solid #e4e4e4;
    &.last {
        border: none;
    }
    .notification {
        text-align: left;
        background-color: #f9f9f9;
        margin-bottom: 12px;
        h3 {
            color: cadetblue;
            font-family: 'Roboto Slab', serif;
            font-size: 1.1rem;
            margin-bottom: 8px;
            &.red {
                color: red;
            }
        }
        .field-prompt {
            margin-bottom: 12px;
        }
    }
    .padded-hr {
        margin: 2rem 0;
    }
}
.review-form {
    text-align: left;
    .review-field {
        margin-bottom: 12px;
        input {
            padding: 15px 12px;
            height: auto;
        }
    }
}
.crew-member {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 12px;
    border: 1px solid #f0f0f0;
    margin-bottom: 12px;
    position: relative;
    .avatar {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        // background: #f0f0f0;
        // color: #444;
        font-weight: bold;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.2rem;
        margin-right: 12px;
    }
    .delete {
        position: absolute;
        top: 5px;
        right: 5px;
    }
}

.hidden {
    display: none;
}

span {
    &.avatar {
        border-radius: 50%;
        border: none;
        width: 45px;
        height: 45px;
        overflow: hidden;
        display: inline-block;
        vertical-align: middle;
        text-align: center;
        line-height: 45px;
        background: cadetblue;
        color: white;
        font-weight: bold;
        letter-spacing: 1pt;
        margin-right: 0.6rem;
        background-position: center center;
        background-size: cover;
        transition: 0.3s;
    }
}

.save-for-later {
    position: fixed;
    bottom: 30px;
    right: 20px;
    border-radius: 50%;
    background-color: cadetblue;
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;
    cursor: pointer;
    transition: 0.25s;
    width: 100px;
    height: 100px;
    &:hover {
        transform: scale(1.1);
    }
    .save-icon {
        font-size: 1.3rem;
        line-height: 1.8rem;
    }
    .save-text {
        line-height: 1.1rem;
        font-size: 1rem;
        font-weight: bold;
        width: 75px;
    }
    &.open-logs {
        background: orange;
        bottom: 150px;
    }
}
.description {
    text-align: center;
}
.vessel-name {
    text-align: center;
    margin: 5px auto 10px;
}

.text-field {
    display: flex;
    justify-content: space-around;
    .text-input {
        width: calc(100% - 60px);
    }
    .text-remove {
        width: 50px;
        .button {
            padding: 12px 18px;
            height: auto;
        }
    }
    &.first {
        .text-input {
            width: 100%;
            margin-left: 2px;
        }
    }
}
.key-field {
    margin-top: 7px;
    font-weight: bold;
}

.alert-bar {
    width: 100%;
    padding: 10px 20px;
    margin-bottom: 2rem;
    background-color: orange;
    color: white;
    position: fixed;
    top: 55px;
    left: 0;
    z-index: 999;
}

.checkbox-wrapper {
    .field {
        text-indent: -2rem;
        margin-left: 2em;
    }
}

ul.uploads {
    list-style: none;
    // height: 250px;
    height: auto;
    margin-bottom: 2rem;

    .sorting-list {
        display: inline-flex;
        height: 100%;
    }

    li {
        display: inline-flex;
        max-width: 200px;
        min-width: 100px;
        margin: 0 1rem 1rem 0;
        height: 100%;
        float: left;
        // padding: 15px;
        border: 1px solid #ddd;
        position: relative;
        cursor: pointer;

        img {
            width: 100%;
            align-self: center;
        }

        .cross {
            justify-content: center;
            position: absolute;
            top: -12px;
            right: -12px;
            z-index: 39;
            background: #dedede;
            padding: 10px;
            width: 35px;
            height: 35px;
            display: flex;
            border-radius: 50%;
            transition: 0.2s;
            cursor: pointer;

            &:hover {
                color: red;
            }
        }
    }
}

.notification {
    cursor: pointer;
    margin-bottom: 12px;
    transition: 0.25s;
    // &.flex {
    //     display: flex;
    //     align-items: flex-start;
    //     max-width: 400px;
    //     margin-bottom: 16px;
    // }
    &.left {
        text-align: left;
    }
    .log-icon {
        margin-right: 10px;
        transition: 0.25s;
        width: 18px;
    }
    .log-name {
        width: calc(100% - 30px);
    }
    &:hover {
        color: cadetblue;
        .log-icon {
            transform: scale(1.2);
        }
    }
    .locked {
        position: absolute;
        top: 5px;
        right: 9px;
        font-size: 13px;
        color: red;
    }
}

.input-table {
    .input.borderless {
        border: none;
        box-shadow: none;
        background: transparent;
        padding: 12px 12px;
        &.theader {
            font-weight: bold;
            background: #f4f4f4;
            text-transform: uppercase;
        }
        &.cell-locked {
            // background: red;
            // color: #888;
        }
    }
    tr {
        td {
            position: relative !important;
            .toggle-type {
                opacity: 0;
                display: flex;
                position: absolute;
                top: 5px;
                right: 5px;
                background: #f4f4f4;
                align-items: center;
                justify-content: center;
                color: deepskyblue;
                width: 30px;
                height: 30px;
                border-radius: 50%;
                font-size: 13px;
                cursor: pointer;
                transition: 0.3s;
            }
            &:hover {
                .toggle-type {
                    opacity: 1;
                }
            }
            &.greyed {
                // background: #f4f4f4;
            }
            .check-cell {
                padding: 12px 0;
                color: #888;
            }
        }
    }
}

@media screen and (max-width: 769px) {
    .desktop {
        display: none;
    }
}
@media screen and (max-width: 500px) {
    .save-for-later {
        width: 85px;
        height: 85px;
        bottom: 20px;
        .save-icon {
            font-size: 1rem;
            line-height: 1.2rem;
        }
        .save-text {
            line-height: 1rem;
            font-size: 0.9rem;
        }
        &.open-logs {
            bottom: 120px;
        }
    }
}
</style>
